export default "__VITE_ASSET__BSoJILv7__"